function sanitizeInput(input) {
    const escapeCharsMap = {
        '&': '&#38;',
        '<': '&#60;',
        '>': '&#62;',
        '=': '&#61;',
        '+': '&#43;',
        '(': '&#40;',
        ')': '&#41;',
        '[': '&#91;',
        ']': '&#93;',
        '/': '&#47;',
        '\\': '&#92;',
        ':': '&#58;',
        ';': '&#59;',
        '!': '&#33;',
        '#': '&#35;',
        '@': '&#64;'
    };
    if (input?.length) return input.replace(/[&<>=+()[\]/\\:;!#@\s]/g, (char)=>escapeCharsMap[char] ?? char);
    return input;
}
export { sanitizeInput as default };
